import {
    getAsync,
    postAsync
} from "../helpers/apiHelper";

const endpoint = process.env.VUE_APP_BACKEND + "/api/Session";

// GET session by id
export async function getSessionAsync(Id) {
    return await getAsync(`${endpoint}/${Id}`);
}

// UPDATE sessions indexes
export async function updateSessionIndexesAsync(sessions) {
    return await postAsync(`${endpoint}/UpdateSessionIndexes`, sessions, false);
}
